<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  
  .step-title
    span Select your mining hardware
  
  .columns
    .column(v-for="o in miningTypes")
      .box-container.is-flex.fdc.jcc.aic
        .element-box-container.text-only(@click="select(o.code)")
          span.name {{ o.name }}
        .box-explanation
          span {{ o.description }}
</template>

<script>
export default {
  name: 'c_step1_mining_type',
  data () {
    return {
      miningTypes: [
        {
          'code': 'gpu',
          'name': 'Graphics Card (GPU)',
          'icon': 'fa-microchip',
          'description': 'Get the best performance and rewards with GPU mining, be sure to previously check the minimum hardware requirements'
        },
        {
          'code': 'cpu',
          'name': 'CPU',
          'icon': 'fa-microchip',
          'description': `Use your CPU for mining if you don't have a dedicated GPU available or it doesn't meet the minimum hardware requirements`
        }
      ]
    }
  },
  mounted () {
    document.getElementById('step').scrollIntoView();
  },
  methods : {
    select (code) {
      let vm = this
      vm.$emit('selected', code)
    }
  }
}
</script>

<style lang="stylus" scoped>
@media (max-width: 768px)
  .step-explanation
    margin-bottom 20px
  .box-container
    margin-top 0px
</style>



// WEBPACK FOOTER //
// c_step_mining_type.vue?7830f7e3